import { render, staticRenderFns } from "./client-chat-wrap.vue?vue&type=template&id=2c762c23"
import script from "./client-chat-wrap.vue?vue&type=script&lang=js"
export * from "./client-chat-wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports